import { render, staticRenderFns } from "./k-field-display.vue?vue&type=template&id=ca71e54e&scoped=true"
import script from "./k-field-display.vue?vue&type=script&lang=js"
export * from "./k-field-display.vue?vue&type=script&lang=js"
import style0 from "./k-field-display.vue?vue&type=style&index=0&id=ca71e54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca71e54e",
  null
  
)

export default component.exports